import React, {useEffect} from "react";
import useInView from "./utils/useInView";
import {useAbout, useGetAbout} from "./stores/otherStore";

const AboutCompany = () => {
    const [ref, inView] = useInView();
    const about = useAbout();
    const getAbout = useGetAbout();

    useEffect(() => {
        void getAbout();
    }, [getAbout]);
    return (
        <div
            ref={ref}
            className={`opacity-0 scale-90 transition-all duration-500 
        ${inView ? "animate-fadeIn" : ""}`}
        >
            <div className='bg-[#f8f9fa] lg:mt-10 px-5'>
                <div className="container lg:grid lg:grid-cols-3 gap-20 p-10 px-24">
                    {about.map((item, index) => {
                        const paragraphs = item.description.split(/\r?\n/);
                        return (
                            <>
                                <div className='lg:h-[350px] min-h-60 lg:bg-cover bg-contain bg-no-repeat bg-center'
                                     style={{backgroundImage: `url(${item.image})`}}></div>

                                <div className='col-span-2'>
                                    <div key={index}>
                                        <h2 className='text-2xl text-[#212529] mt-10 font-bold'>{item.title}</h2>
                                        {paragraphs.map((para, i) => (
                                            <p key={i} className='mt-4 text-[#212529]'>{para.trim()}</p>
                                        ))}
                                    </div>

                                </div>
                            </>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default AboutCompany;
